const createActionType = (module, actionName) => `/${module}/${actionName}`;

export default createActionType;
